import { activestatus } from 'api/rcpapiService';
import { unregisterFCM } from '../../../firebase';
import { useHistory } from 'react-router-dom';
function Logout() {
  const history = useHistory();
  activestatus(false); // Set user as inactive on logout

  localStorage.setItem('isLogin', '');
  localStorage.removeItem('userDetails');
  localStorage.removeItem('moxoDetail');
  localStorage.removeItem('moxoUserId');
  localStorage.removeItem('userDetail');
  localStorage.removeItem('userType');
  localStorage.removeItem('lastSeenUser');
  localStorage.removeItem('token');
  localStorage.removeItem('accesstoken');
  localStorage.removeItem('tempid');
  localStorage.removeItem('legalsliderval');
  localStorage.removeItem('propertyId');
  localStorage.removeItem('notificationaudio');
  localStorage.removeItem('dashboardCount');
  localStorage.removeItem('issurveyskipped');
  localStorage.removeItem('audiofiles');
  localStorage.removeItem('errorLogs');
  localStorage.setItem('buyerSolicitor', '');
  localStorage.setItem('buyerSolicitorDetails', '');
  window.chmln?.clear();
  sessionStorage.clear();
  history.push('/login');

  // unregisterFCM();
  return null;
}

export default Logout;
